import React, { Fragment, useMemo } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '../../common/headers/ModalHeader';

// Constants

import { THC_TYPES } from '../../../constants/ssap/hhmTypes/taxRelationsTypes';

// Utils

import { isEqual } from '../../../utils/miscellaneous/objectHelpers';


const MultiTaxHouseholdModal = props => {

    const {
        actions: {
            hideAllModals
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modal: {
            modalData: {
                combinedFilers,
                filers,
                primaryTaxFilerPersonId,
                callbacks
            }
        },
        modalHeaderProps
    } = props;

    const handleHideClick = () => {
        hideAllModals();
    };

    const handleSave = () => {
        callbacks.forEach(cb => cb());
        hideAllModals();
    };

    const primaryTaxFilerName = useMemo(
        () => {
            const primaryTaxFiler = filers.find(f => f.filerPersonId === primaryTaxFilerPersonId);
            return primaryTaxFiler ? primaryTaxFiler.filerFullName : '';
        },
        [ filers, primaryTaxFilerPersonId ]
    );

    const filerPersonIds = useMemo(
        () => {
            return combinedFilers.reduce((filerPersonIds, filer) => {
                const {
                    filerPersonId,
                    taxFilingStatus
                } = filer;

                return (Array.isArray(filerPersonId) && taxFilingStatus === THC_TYPES.FILING_JOINTLY)
                    ? [ ...filerPersonIds, filerPersonId.sort() ]
                    : filerPersonIds;
            }, [ ]);
        },
        [ combinedFilers ]
    );

    const filterEligibleForRenderFiler = f => {
        const {
            isFilingTaxes,
            filerPersonId
        } = f;

        const ids = [ filerPersonId, primaryTaxFilerPersonId ].sort();
        const isFilingJointlyWithPtf = filerPersonIds.some(filerPersonId => isEqual(ids, filerPersonId));

        return filerPersonId !== primaryTaxFilerPersonId && isFilingTaxes && !isFilingJointlyWithPtf;
    };

    const getNonPrimaryTaxFilers = () => {
        return filers
            .filter(filterEligibleForRenderFiler)
            .map(f => {
                const {
                    filerFullName,
                    filerPersonId
                } = f;

                return (
                    <p key = { filerPersonId } >
                        <FormattedMessage
                            id = 'modals.multi_tax_household.who_not_related_to_primary'
                            values = { {
                                personName: <strong>{ filerFullName }</strong>
                            } }
                        />
                    </p>
                );
            });
    };

    return (
        <Fragment>
            <div className = 'gi-modal__header__head' >
                <ModalHeader
                    { ...modalHeaderProps }
                    closeAllModals
                    hideAllModals = { hideAllModals }
                />
            </div>
            <div
                id = 'multiTaxHouseholdModal'
                className = 'gi-modal__body'
            >
                <FormattedMessage
                    id = 'modals.multi_tax_household.only_who_related_to_primary'
                    values = { {
                        personName: <strong>{ primaryTaxFilerName }</strong>
                    } }
                    tagName='p'
                />
                {
                    getNonPrimaryTaxFilers()
                }
            </div>
            <div className = 'gi-modal__footer' >
                <div className = 'grid-row controls' >
                    <div className = 'grid-offset-4 txt-left' >
                        <Button
                            className = 'usa-button usa-button--outline gi-button gi-button__outline'
                            onClick = { handleHideClick }
                        >
                            <FormattedMessage id = 'button.cancel' />
                        </Button>
                        <Button
                            className = 'usa-button gi-button gi-button__primary'
                            onClick = { handleSave }
                            inputRef = { boundAnchor(anchor_1) }
                        >
                            <FormattedMessage id = 'button.save' />
                        </Button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default MultiTaxHouseholdModal;
